// The new checkout, when enabled and the presale can use it (the API returns no checkout_url for
// novated, employee-benefit and group-subscription presales). Partner sites keep the legacy order flow.
export const useCheckoutPath = () => {
	const runtimeConfig = useRuntimeConfig()
	const { partnerName } = useGetPartnerName()

	return (
		presale?: { uuid?: string; checkout_url?: string | null } | null
	) =>
		runtimeConfig.public.CHECKOUT_V2_ENABLED &&
		presale?.checkout_url &&
		!partnerName.value
			? `/checkout/${presale.uuid}`
			: null
}
